import { useCallback, useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { iAxios } from "../../../lib/utils";
import { alertMessage } from "../../../lib/actions";
import { GenericForm } from "../../common/GenericForm";
import { ZohoConnect } from "./ZohoConnect";
import moment from "moment";


const JiraConnectConfig = [{
    name: 'server',
    label: 'Jira Server URL'
}, {
    name: 'email',
    label: 'User Email Id',
}, {
    name: 'token',
    label: 'Auth Token Generated from Settings'
}]

const JiraCard = ({ item, loadData }) => {

    const dispatch = useDispatch();
    const [search, setSearch] = useState();
    const [userList, setUserList] = useState([]);

    const handleStatusChange = (e) => {
        iAxios.post('/api/v1/admin/update-source-status', {
            sourceId: item.id,
            status: e.target.value
        }).then(resp => { 
            if (!resp.data.success) {
                dispatch(alertMessage(`Unable to update status of ${item.name}`))
                return
            }
            dispatch(alertMessage(`Status of ${item.name} updated to ${resp.data.data.status}`))
            loadData()
        })
    }
    const createMapping = (e) => {
        e.preventDefault();
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = {}
        for (const [key, value] of formData) {
            data[key] = value;
        }
        iAxios.post('/api/v1/admin/jira-create-user-mapping', data).then(resp => {
            console.log(resp);
            setUserList([]);
        }).catch(ex=>{
            alert(ex.message)
        })
        console.log(data);
    }

    const handleFetchUsers = () => {
        iAxios.get('/api/v1/admin/jira-fetch-users', {
            params: {
                sourceId: item.id,
                search
            }
        }).then(res => {
            setUserList(res.data.data);
        })
    }

    let sycedTime = 'Never';
    if (moment(item.syncedAt).isAfter('2010-01-01')) {
        sycedTime = moment(item.syncedAt).fromNow();
    }

    return <div className="ds-card" style={{ marginBottom: 'var(--ds-space-3)', borderLeft: `3px solid ${item.status === 'Active' ? 'var(--ds-success)' : 'var(--ds-danger)'}` }}>
        <div className="ds-field-row" style={{ marginBottom: 'var(--ds-space-2)', alignItems: 'flex-start' }}>
            <div className="ds-field">
                <h4>{item.name}</h4>
                <div style={{ color: 'var(--ds-ink-muted)', fontSize: 'var(--ds-text-sm)' }}>
                    Server: {item.server}<br />
                    Project: {item.team}<br />
                    Last synced: {sycedTime}
                </div>
            </div>
            <select onChange={handleStatusChange} className="ds-select" style={{ maxWidth: '140px' }} defaultValue={item.status} aria-label="Source status">
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
            </select>
        </div>

        {item.status === 'Active' && <div>
            {userList.length === 0 && <div className="ds-field-row" style={{ marginBottom: 0 }}>
                <input className="ds-input ds-field" type="text" placeholder="Search Jira users" onChange={e => setSearch(e.target.value)} />
                <button className="ds-btn is-soft" onClick={handleFetchUsers}>Search users</button>
            </div>}

            {userList.length > 0 && <form onSubmit={createMapping}>
                {userList.map((mapItem, idx) => (
                    <div className="ds-field-row" key={mapItem.accountId} style={{ marginBottom: 'var(--ds-space-2)', alignItems: 'center' }}>
                        <span className="ds-nums">{idx + 1}</span>
                        <span style={{ flex: '1 1 160px' }}>{mapItem.displayName}</span>
                        <input className="ds-input ds-field" placeholder="Map to email id" name={`${mapItem.accountId}`} />
                    </div>
                ))}
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 'var(--ds-space-3)' }}>
                    <button type="button" className="ds-btn is-ghost" onClick={() => setUserList([])}>Cancel</button>
                    <button className="ds-btn is-primary">Submit</button>
                </div>
            </form>}
        </div>}
    </div>;

}

const InfoBody = ({ data }) => {
    return <div>
        {data.newList.length > 0 && <div>New
            <ul>
                {data.newList.map(item => <li>{item.name} from {item.server}</li>)}
            </ul>
        </div>
        }
        {data.existing.length > 0 && <div>Existing
            <ul>
                {data.existing.map(item => <li>{item.name} from {item.server}</li>)}
            </ul>
        </div>}
    </div>
}

const JiraConnect = ({ sources, loadData }) => {
    const [projects, setProjects] = useState([]);
    const [selectedProjects, setSelectedProjects] = useState([]);
    const [syncData, setSyncData] = useState(null);
    const userInfo = useSelector(st => st.userInfo);
    const dispatch = useDispatch();
    const connectJira = (data) => {
        iAxios.post('/api/v1/admin/jira-connect', data).then(resp => {
            console.log(resp.data);
            setProjects(resp.data);
            setSyncData(data);
        })
    }
    const onSelectionChange = (e) => {
        if (e.target.checked) {
            setSelectedProjects([e.target.value, ...selectedProjects]);
        } else {
            setSelectedProjects(selectedProjects.filter(item => item !== e.target.value))
        }
    }

    const connectProjects = (e) => {
        e.preventDefault();

        iAxios.post('/api/v1/admin/jira-connect-projects', {
            authData: syncData,
            projectList: projects,
            selectedProjects
        }).then(resp => {
            console.log(resp.data);

            dispatch(alertMessage(<InfoBody data={resp.data} />, 'Synced Projects Successfully'))
        })
    }

    return <div>
        <h3>Jira</h3>
        <div className="integ-lede">Integrate your projects, sprints and tickets from Jira.</div>
        <div>
            {projects.length === 0 && <div style={{ marginBottom: 'var(--ds-space-4)' }}>
                <GenericForm fields={JiraConnectConfig}
                    onSubmit={connectJira}
                    initVals={{ emailId: userInfo?.email }}
                    submitLabel="Connect Jira"
                    wrapClass='ds-form-field'
                    fieldClass='ds-input' />
                <a href="https://id.atlassian.com/manage-profile/security/api-tokens" target="_blank" rel="noreferrer">Create a token here</a>
            </div>}
            {projects.length > 0 &&
                <form className="ds-panel" style={{ padding: 0, marginBottom: 'var(--ds-space-4)' }} onSubmit={connectProjects}>
                    <div className="ds-panel__head"><h3 className="ds-panel__title">Select projects to sync</h3></div>
                    <div className="ds-panel__body">
                        {projects.map((item, idx) => (
                            <label key={item.key} style={{ display: 'block', padding: 'var(--ds-space-3) 0', borderBottom: '1px solid var(--ds-border)' }}>
                                <input type="checkbox" onChange={onSelectionChange} value={item.key} checked={selectedProjects.includes(item.key)} style={{ float: 'right', accentColor: 'var(--ds-accent)' }} />
                                <b>{idx + 1}. {item.name}</b><br />
                                <span style={{ color: 'var(--ds-ink-muted)', fontSize: 'var(--ds-text-sm)' }}>Key: {item.key} · Id: {item.id}</span>
                            </label>
                        ))}
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 'var(--ds-space-4)' }}>
                            <button type="button" className="ds-btn is-ghost" onClick={() => setProjects([])}>Cancel</button>
                            <button className="ds-btn is-primary">Sync projects</button>
                        </div>
                    </div>
                </form>}
            <div style={{ marginTop: 'var(--ds-space-4)' }}>
                {sources.filter(item => item.type === 'jira').map(item => <JiraCard key={item.id} item={item} loadData={loadData} />)}
            </div>
        </div>
    </div>;
};

export const Integrations = (props) => {
    const [integrations, setIntegrations] = useState([]);
    const [sources, setSources] = useState([]);
    const dispatch = useDispatch();


    const loadData = useCallback(() => {
        iAxios.get('/api/v1/admin/integrations').then(resp => {
            setIntegrations(resp.data.data);
        }).catch(ex => {
            dispatch(alertMessage(ex.message))
        })
        iAxios.get('/api/v1/admin/sources').then(resp => {
            setSources(resp.data.data.sort((a, b) => a.status.localeCompare(b.status)));
        }).catch(ex => {
            dispatch(alertMessage(ex.message))
        })
    }, [1])

    useEffect(() => {
        loadData()
    }, [1])


    return <div className="integ-stack">
        <ZohoConnect integrations={integrations} loadData={loadData} />

        <div className="ds-panel">
            <h3>OpenAI</h3>
            <div className="integ-lede">Add your OpenAI API key for AI features.</div>
            <div className="ds-field-row" style={{ marginBottom: 0 }}>
                <input className="ds-input ds-field" type="text" name="openAIKey" placeholder="OpenAI key" />
                <button className="ds-btn is-primary">Save API key</button>
            </div>
        </div>

        <div className="ds-panel">
            <h3>Google Chat</h3>
            <div className="integ-lede">Grant access to manage Google Chat messages for automated notifications and message cleanup.</div>
            <a className="ds-btn is-primary" href="/auth/google-chat">Grant Google Chat access</a>
        </div>

        <div className="ds-panel" style={{ display: 'none' }}>
            <h3>GitLab</h3>
            <div className="integ-lede">Integrate your employee details, projects and tickets with GitLab.</div>
            <input className="ds-input" style={{ marginBottom: 'var(--ds-space-3)' }} type="text" name="gitlabServer" placeholder="GitLab server URL" />
            <input className="ds-input" style={{ marginBottom: 'var(--ds-space-3)' }} type="text" name="gitlabAccessToken" placeholder="GitLab personal access token" />
            <input className="ds-input" style={{ marginBottom: 'var(--ds-space-3)' }} type="text" name="gitlabServiceId" placeholder="GitLab service account id" />
            <input className="ds-input" style={{ marginBottom: 'var(--ds-space-3)' }} type="text" name="gitlabServiceToken" placeholder="GitLab service account token" />
            <a className="ds-btn is-primary" href="/auth/zoho">Connect GitLab</a>
        </div>

        <div className="ds-panel">
            <JiraConnect sources={sources} loadData={loadData} />
        </div>
    </div>;

}